// extracted by mini-css-extract-plugin
module.exports = {"a-button-svg-icon":"ButtonSvgIcon_a-button-svg-icon__Ptdf4","-active":"ButtonSvgIcon_-active__uDu5k","-disabled":"ButtonSvgIcon_-disabled__U__fs"};